import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Wedding from '@/components/Wedding'
import Birthday from '@/components/Birthday'
import Cupcakes from '@/components/Cupcakes'
import Other from '@/components/Other'
import Contact from '@/components/Contact'
import Edit from '@/components/Edit'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/wedding',
      name: 'Wedding',
      component: Wedding
    },
    {
      path: '/birthday',
      name: 'Birthday',
      component: Birthday
    },
    {
      path: '/other',
      name: 'Other',
      component: Other
    },
    {
      path: '/cupcakes',
      name: 'Cupcakes',
      component: Cupcakes
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/edit',
      name: 'Edit',
      component: Edit,
      beforeEnter: (to, from, next) => {
        localStorage.getItem('user') === null ? next('/login') : next()
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        localStorage.getItem('user') !== null ? next('/edit') : next()
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js